export default "__VITE_ASSET__CH2$iBhg__"